import { AxiosRequestConfig } from 'axios';
import { BRAND_ID_HEADER_KEY } from '../../../services/api';
import { ACTION_TO_ORDER_STATUS_MAP } from '../actions/orderSummaryActions';
import { ActionEnum } from '../actions/types/orderActions.types';
import { ordersRepository } from './ordersRepository/orders.repository';

type UpdateOrderStatusRepository = {
  action: ActionEnum;
  orderId: string;
  reason?: string;
  brandId?: string;
};

export const updateOrderStatusRepository = ({
  action,
  reason,
  orderId,
  brandId,
}: UpdateOrderStatusRepository) => {
  const repository = ordersRepository(orderId);

  let axiosConfig: AxiosRequestConfig = {};
  if (brandId) {
    axiosConfig = { headers: { [BRAND_ID_HEADER_KEY]: brandId } };
  }

  const desiredStatus = ACTION_TO_ORDER_STATUS_MAP[action];

  switch (action) {
    case ActionEnum.BACK_TO_DRAFT:
      return repository.changeOrderStatus({ status: desiredStatus }, axiosConfig);
    case ActionEnum.BACK_TO_IN_REVISION:
    case ActionEnum.FINISH_TO_IN_REVISION:
      return repository.changeOrderStatus({ status: desiredStatus }, axiosConfig);
    case ActionEnum.BACK_TO_ON_APPROVAL:
    case ActionEnum.FINISH_TO_ON_APPROVAL:
      return repository.changeOrderStatus({ status: desiredStatus }, axiosConfig);
    case ActionEnum.BACK_TO_APPROVED:
    case ActionEnum.FINISH_TO_APPROVED:
      return repository.changeOrderStatus({ status: desiredStatus }, axiosConfig);
    case ActionEnum.MOVE_TO_SENT:
      return repository.changeOrderStatus({ status: desiredStatus }, axiosConfig);
    case ActionEnum.MOVE_TO_CANCELED:
      return repository.changeOrderStatus({ status: desiredStatus, reason }, axiosConfig);
    case ActionEnum.MOVE_TO_REJECTED:
      return repository.changeOrderStatus({ status: desiredStatus, reason }, axiosConfig);
    case ActionEnum.ARCHIVE_ORDER:
      return repository.archiveOrder(axiosConfig);
    case ActionEnum.UNARCHIVE_ORDER:
      return repository.unarchiveOrder(axiosConfig);
    default:
      throw Error('Nenhuma ação encontrada');
  }
};
